"use client";

import { useEffect } from "react";

import {
  applyTheme,
  DEFAULT_THEME,
  getResolvedTheme,
  readStoredTheme,
  setStoredTheme,
  subscribeTheme,
  type ThemeMode,
} from "@/lib/theme";

export function ThemeBootstrap({
  serverTheme = null,
}: {
  serverTheme?: ThemeMode | null;
}) {
  useEffect(() => {
    if (!readStoredTheme()) {
      setStoredTheme(serverTheme ?? DEFAULT_THEME);
    }

    return subscribeTheme(() => applyTheme(getResolvedTheme()));
  }, [serverTheme]);

  return null;
}
